import * as React from "react";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";

import { cn } from "../lib/utils";

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <HoverCardPrimitive.Content
    ref={ref}
    align={align}
    sideOffset={sideOffset}
    className={cn(
      "tw-figr-z-50 tw-figr-w-80 tw-figr-rounded-md tw-figr-border tw-figr-bg-base-white tw-figr-p-m tw-figr-font-secondary tw-figr-text-base-black tw-figr-shadow-md tw-figr-outline-none data-[state=open]:tw-figr-animate-in data-[state=closed]:tw-figr-animate-out data-[state=closed]:tw-figr-fade-out-0 data-[state=open]:tw-figr-fade-in-0 data-[state=closed]:tw-figr-zoom-out-95 data-[state=open]:tw-figr-zoom-in-95 data-[side=bottom]:tw-figr-slide-in-from-top-2 data-[side=left]:tw-figr-slide-in-from-right-2 data-[side=right]:tw-figr-slide-in-from-left-2 data-[side=top]:tw-figr-slide-in-from-bottom-2",
      className
    )}
    {...props}
  />
));
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent };
